module.exports = __webpack_public_path__ + "assets/img/station22.4fb43096.png";